import React from 'react'
import Logo from '../common/Logo'

function LegalLayout({ title, children, onRetour }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Inter, -apple-system, sans-serif' }}>
      <header style={{ background: 'white', borderBottom: '1px solid #e2e8f0', padding: '0 24px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Logo size="md" withText={true} />
        <button onClick={onRetour} style={{ background: 'none', border: '1.5px solid #e2e8f0', borderRadius: 8, padding: '7px 16px', fontSize: 13, cursor: 'pointer', color: '#4a5568' }}>
          Retour
        </button>
      </header>
      <main style={{ maxWidth: 760, margin: '48px auto', padding: '0 24px 80px' }}>
        <h1 style={{ fontSize: 30, fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>{title}</h1>
        <p style={{ fontSize: 13, color: '#a0aec0', marginBottom: 40 }}>Derniere mise a jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
        <div style={{ background: 'white', borderRadius: 14, padding: '40px 48px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', lineHeight: 1.75, color: '#374151', fontSize: 15 }}>
          {children}
        </div>
      </main>
    </div>
  )
}

function H2({ children }) {
  return <h2 style={{ fontSize: 18, fontWeight: 700, color: '#0f172a', marginTop: 36, marginBottom: 10, borderBottom: '2px solid #e8f7f2', paddingBottom: 8 }}>{children}</h2>
}
function P({ children }) {
  return <p style={{ marginBottom: 14 }}>{children}</p>
}

export default function MentionsLegales({ onRetour }) {
  return (
    <LegalLayout title="Mentions legales" onRetour={onRetour}>
      <H2>1. Editeur du site</H2>
      <P>Le service Suiveo BTP est edite par la societe <strong>[NOM DE LA SOCIETE]</strong>, [forme juridique — ex : SAS au capital de X euros], dont le siege social est situe au <strong>[ADRESSE COMPLETE]</strong>.</P>
      <P>SIRET : <strong>[NUMERO SIRET]</strong><br />
      Numero de TVA intracommunautaire : <strong>[NUMERO TVA]</strong><br />
      Email de contact : <strong>suiveo.btp@gmail.com</strong></P>
      <P>Directeur de la publication : <strong>[NOM DU DIRIGEANT]</strong></P>

      <H2>2. Hebergement</H2>
      <P>Le site est heberge par :<br />
      <strong>Supabase, Inc.</strong><br />
      970 Toa Payoh North, Singapour 318992<br />
      Site web : <a href="https://supabase.com" style={{ color: '#1D9E75' }}>supabase.com</a></P>
      <P>L infrastructure front-end est deployee via <strong>Vercel, Inc.</strong>, 440 N Barranca Ave #4133, Covina, CA 91723, USA.</P>

      <H2>3. Propriete intellectuelle</H2>
      <P>L ensemble des elements du site Suiveo BTP (textes, graphismes, logiciels, photographies, images, sons, plans, noms, logos, marques, creation graphique) sont la propriete exclusive de [NOM DE LA SOCIETE] ou font l objet de licences accordees a [NOM DE LA SOCIETE].</P>
      <P>Toute reproduction, representation, modification, publication, adaptation de tout ou partie des elements du site, quel que soit le moyen ou le procede utilise, est interdite, sauf autorisation ecrite prealable de [NOM DE LA SOCIETE].</P>

      <H2>4. Donnees personnelles</H2>
      <P>Les donnees collectees sur Suiveo BTP (adresse email, nom, prenom) sont utilisees exclusivement dans le cadre de la fourniture du service. Elles ne sont pas vendues ni transmises a des tiers.</P>
      <P>Conformement au Reglement General sur la Protection des Donnees (RGPD) et a la loi Informatique et Libertes, vous disposez d un droit d acces, de rectification, de portabilite et d effacement de vos donnees. Pour exercer ces droits, contactez-nous a : <strong>privacy@chantierpro.fr</strong></P>
      <P>Pour toute reclamation, vous pouvez egalement contacter la CNIL (Commission Nationale de l Informatique et des Libertes) : <a href="https://www.cnil.fr" style={{ color: '#1D9E75' }}>www.cnil.fr</a></P>

      <H2>5. Cookies</H2>
      <P>Le site Suiveo BTP utilise des cookies techniques strictement necessaires au fonctionnement du service (session d authentification, preferences utilisateur). Aucun cookie de tracking publicitaire n est utilise.</P>

      <H2>6. Limitation de responsabilite</H2>
      <P>[NOM DE LA SOCIETE] ne pourra etre tenu responsable des dommages directs ou indirects susceptibles de resulter de l acces ou de l utilisation du site, y compris des inaccessibilites, pertes de donnees, deteriorations, destructions ou virus pouvant affecter l equipement de l utilisateur.</P>

      <H2>7. Droit applicable</H2>
      <P>Les presentes mentions legales sont soumises au droit francais. En cas de litige, les tribunaux francais sont seuls competents.</P>
    </LegalLayout>
  )
}
